<template>
  <!-- 端午活动-活动配置 -->
  <div class="debris_formula_config-box">
    <!-- header头部 -->
    <header>
      <h2>端午活动配置</h2>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-form label-width="200px">
        <br />
        <h3 style="color: #409eff">流水经验值增加：</h3>
        <br />
        <el-form-item label="倍数">
          <el-input
            style="width: 120px"
            v-model.trim="formData1.number"
            placeholder="请输入倍数"
          ></el-input>
        </el-form-item>
        <el-form-item label="流水经验值增加时间">
          <el-date-picker
            style="width: 200px"
            v-model="formData1.start_time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="开始时间"
          >
          </el-date-picker>
          ->
          <el-date-picker
            style="width: 200px"
            v-model="formData1.end_time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="结束时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-switch
            v-model="formData1.switch_status"
            active-text="开启流水经验值增加"
            inactive-text="关闭流水经验值增加"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="submit1()"
            >保存</el-button
          >
        </el-form-item>
      </el-form>
      <br />

      <h3 style="color: #409eff">热血盲盒排行榜：</h3>
      <el-form label-width="200px">
        <br />
        <el-form-item label="积分排行榜倍数">
          <el-input
            style="width: 120px"
            v-model.trim="formData2.score_number"
            placeholder="请输入倍数"
          ></el-input>
        </el-form-item>
        <el-form-item label="非酋榜倍数">
          <el-input
            style="width: 120px"
            v-model.trim="formData2.non_chieftain_number"
            placeholder="请输入倍数"
          ></el-input>
        </el-form-item>
        <el-form-item label="热血盲盒排行榜奖励时间">
          <el-date-picker
            style="width: 200px"
            v-model="formData2.start_time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="开始时间"
          >
          </el-date-picker>
          ->
          <el-date-picker
            style="width: 200px"
            v-model="formData2.end_time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="结束时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-switch
            v-model="formData2.switch_status"
            active-text="开启热血盲盒排行榜奖励"
            inactive-text="关闭热血盲盒排行榜奖励"
            :active-value="1"
            :inactive-value="0"
          ></el-switch>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="submit2()"
            >保存</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'

export default {
  data() {
    return {
      loading: false,//加载动画
      formData1: {
        switch_status: 0,
        start_time: '',
        end_time: '',
        number: ''
      },
      formData2: {
        switch_status: 0,
        start_time: '',
        end_time: '',
        score_number: '',
        non_chieftain_number: ''
      }
    }
  },
  created() {
    this.getData1()
    this.getData2()
  },
  methods: {
    getData1() {
      this.loading = true
      getApiData('water_exp_configs').then(res => {
        if (res) {
          this.formData1 = res
          this.formData1.start_time = this.$formatTime.wayOne(this.formData1.start_time * 1000, "YYYY-mm-dd HH:MM:SS")
          this.formData1.end_time = this.$formatTime.wayOne(this.formData1.end_time * 1000, "YYYY-mm-dd HH:MM:SS")
        }
      }).finally(() => {
        this.loading = false
      })
    },
    getData2() {
      this.loading = true
      getApiData('battle_ranking_configs').then(res => {
        if (res) {
          this.formData2 = res
          this.formData2.start_time = this.$formatTime.wayOne(this.formData2.start_time * 1000, "YYYY-mm-dd HH:MM:SS")
          this.formData2.end_time = this.$formatTime.wayOne(this.formData2.end_time * 1000, "YYYY-mm-dd HH:MM:SS")
        }
      }).finally(() => {
        this.loading = false
      })
    },
    submit1() {
      //提交
      let params = this.formData1
      params.start_time = new Date(this.formData1.start_time) / 1000
      params.end_time = new Date(this.formData1.end_time) / 1000
      patchApiData(`water_exp_configs`, params).then(res => {
        if (res.code === 1) {
          this.$message.success(res.message)
          this.getData1()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    submit2() {
      //提交
      let params = this.formData2
      params.start_time = new Date(this.formData2.start_time) / 1000
      params.end_time = new Date(this.formData2.end_time) / 1000
      patchApiData(`battle_ranking_configs`, params).then(res => {
        if (res.code === 1) {
          this.$message.success(res.message)
          this.getData2()
        } else {
          this.$message.error(res.message)
        }
      })
    },
  }

}
</script>
<style lang="less" scoped>
.debris_formula_config-box {
  header {
  }

  .body-box {
    width: 800px;
  }
}
</style>